'use strict';
import angular from 'angular';
import moment from 'moment';

export default class LanguesController {
  /*@ngInject*/
  constructor($stateParams, $http, $state, $scope, $timeout, $location, Borne) {
    var vm = this;
    var first = true;
    vm.loading = true;
    vm.electron = window.electron;

    vm.selectLangue = function(langue){
      vm.selectedLangue = langue;
      Borne.changeLanguage(langue);
      vm.goToCollecte();
    }

    vm.goToCollecte = function(){
      if(Borne.Poste.Session.expired && first) {
        $('#expiryBadgeModal').modal("show");
        first = false;
      } else if(Borne.Poste.Session.scanned && first) {
        $('#editBadgeModal').modal("show");
        first = false;
      } else {
        $('#editBadgeModal').modal("hide");
        $('#expiryBadgeModal').modal("hide");
        $location.path('/borne_collecte/' + Borne.Poste.selectedCategorie._id+ '/' + Borne.Poste._id);
      } 
    }

    vm.validateBadge = function(){
      if(Borne.Poste.Session.expired) vm.goToCollecte();
      else if(Borne.Poste.Session.badge.active) vm.goOut();
      else {
        Borne.Poste.Session.badge.session.entrees.push({date : new Date});
        Borne.Poste.Session.badge.active = true;
        Borne.Poste.Session.badge.exitTime = _.find(Borne.Poste.Categories, ['_id', Borne.Poste.Session.badge.session.category._id]).autoEndTimer;
        $http.patch('/api/badges/' + Borne.Poste.Session.badge._id, Borne.Poste.Session.badge).then(function(){
          vm.loading = false;
          $('#valideBadgeModal').modal("show");
          $timeout(function(){
            $('#valideBadgeModal').modal("hide");
            vm.borne.returnToMain();
          },5000)
        })
      }
    }

    vm.goOut = function(){
      _.last(Borne.Poste.Session.badge.session.entrees).sortie = new Date;
      Borne.Poste.Session.badge.active = false;
      $http.patch('/api/badges/' + Borne.Poste.Session.badge._id, Borne.Poste.Session.badge).then(function(){
        vm.loading = false;
        $('#valideExitBadgeModal').modal("show");
        $timeout(function(){
          $('#valideExitBadgeModal').modal("hide");
          vm.borne.returnToMain();
        },5000)
      })
    }

    if(!Borne.Poste) {
      Borne.load($stateParams.id).then(function () {
        Borne.Poste.Categories = _.filter(Borne.Poste.Categories, 'active');
        _(Borne.Poste.Categories).forEach(function(cat){
          cat.titles = _.map(cat.traductions,'categoryName')
        })
        vm.borne = Borne.Poste;
        vm.langues = _(vm.borne.availableLanguages).flatMap('dictionnary.main').value();
        vm.loading = false;
        Borne.changeLanguage(vm.langues[0]);
        Borne.startTimer();
        $scope.$apply();
      })
    } else {
      vm.borne = Borne.Poste;
      vm.langues = [];
      _.forEach(vm.borne.availableLanguages, function(langueDispo){
        if(vm.borne.selectedCategorie.langues.includes(langueDispo.id)) vm.langues.push(langueDispo);
      })
      if(Borne.Poste.Session.badge && _.map(vm.langues, "id").includes(Borne.Poste.Session.badge.session.langueId)) {
        Borne.changeLanguage(vm.langues[_.map(vm.langues, "id").indexOf(Borne.Poste.Session.badge.session.langueId)]);
        vm.validateBadge();
      } else if(Borne.Poste.Session.badge) {
        Borne.changeLanguage(vm.langues[0]);
        vm.validateBadge();
      } else {
        Borne.changeLanguage(vm.langues[0]);
      }
      Borne.startTimer();
      vm.loading = false;
    }
    $('.modal-backdrop').hide();
  }
}


// WEBPACK FOOTER //
// ./client/app/borne/langues/langues.controller.js